import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card card-border p-5" }
const _hoisted_2 = { class: "flex items-center gap-2 mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons text-primary",
  style: {"font-size":"20px"}
}, "auto_awesome", -1)
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = {
  key: 0,
  class: "flex justify-center py-2"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "flex items-center justify-between mb-3" }
const _hoisted_8 = { class: "text-sm text-muted" }
const _hoisted_9 = { class: "flex items-center gap-1" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons text-yellow-400 text-sm" }, "auto_awesome", -1)
const _hoisted_11 = { class: "font-semibold text-primary" }
const _hoisted_12 = {
  key: 0,
  class: "flex items-center justify-between mb-3"
}
const _hoisted_13 = { class: "text-sm text-muted" }
const _hoisted_14 = { class: "flex items-center gap-1" }
const _hoisted_15 = { class: "font-semibold" }
const _hoisted_16 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_17 = { class: "text-xs text-muted mb-2" }
const _hoisted_18 = { class: "flex flex-wrap gap-2" }
const _hoisted_19 = { class: "flex items-center justify-center w-8 h-8 rounded-full bg-primary-light bg-opacity-20" }
const _hoisted_20 = {
  class: "material-icons text-primary",
  style: {"font-size":"18px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("gamification.my_progress")), 1)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_Spinner)
        ]))
      : (_ctx.gamificationContext)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("gamification.points")), 1),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.gamificationContext.reputation), 1)
              ])
            ]),
            (_ctx.gamificationContext.leaderboard_position)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("gamification.rank")), 1),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["material-icons text-sm", _ctx.rankIconColor])
                    }, _toDisplayString(_ctx.rankIcon), 3),
                    _createElementVNode("span", _hoisted_15, "#" + _toDisplayString(_ctx.gamificationContext.leaderboard_position), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.gamificationContext.badges?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("gamification.badges_earned")), 1),
                  _createElementVNode("div", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gamificationContext.badges, (badge) => {
                      return (_openBlock(), _createBlock(_component_Tooltip, {
                        key: badge.id,
                        textValue: badge.name + (badge.description ? ': ' + badge.description : '')
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("span", _hoisted_20, _toDisplayString(badge.icon || "military_tech"), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["textValue"]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
  ]))
}